.container {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  background: var(--lightRed);
  border: 1px solid var(--fudisRed);
  border-radius: 2px;
  padding: 0 1em 0 0.25em;
  border-left-width: 8px;
  margin: 1em 0;
}

.content {
  display: inline-block;
  align-self: center;
  margin: 0.3em 0;
}

.icon {
  font-size: 1.5em;
  width: 1.4em;
  height: 1.4em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 1em;
  font-weight: 400;
  color: var(--darkGray);
  margin: 0.125em 0 0 0.2em;
  padding: 0;
}

.errorList {
  margin: 0.5em 0 0.125em;
  padding-left: 0;
  list-style: none;
}

.item {
  position: relative;
  margin-left: 0.8em;
  padding-left: 0.25em;

  &::before {
    background-color: var(--darkGray);
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(calc(-1 * 0.5em), -50%);
    border-radius: 50%;
    width: 0.2em;
    height: 0.2em;
    content: '';
  }

  &:not(:last-of-type) {
    margin-bottom: 0.5em;
  }

  & > a {
    border-bottom: 1px dashed var(--blueActive);
    color: var(--blueActive)
  }
}
